module.exports = __webpack_public_path__ + "img/25.e054bf22.jpg";